import api from './apiClient'

export default {
  // =========================
  // 📌 GENERAL SETTINGS
  // =========================
  async getSettings() {
    const res = await api.get('/settings')
    return res.data
  },

  async getOauthUrl(data) {
    const res = await api.get('/settings/amazon-business/oauth2-url?redirect_url='+data.redirect_url)
    return res.data
  },
  async saveChannel(data) {
    const res = await api.post('/settings/amazon-business/add-channel', data)
    return res.data
  },

  async getBasicSettings() {
    const res = await api.get('/settings/basic')
    return res.data
  },

  async updateBasicSettings(data) {
    const res = await api.put('/settings/basic', data)
    return res.data
  },

  // =========================
  // 📞 CONTACT SETTINGS
  // =========================
  async getContact() {
    const res = await api.get('/settings/contact')
    return res.data
  },

  async updateContact(data) {
    const res = await api.put('/settings/contact', data)
    return res.data
  },

  // =========================
  // 📄 POLICY LINKS
  // =========================
  async getPolicyLinks() {
    const res = await api.get('/settings/policy-links')
    return res.data
  },

  async createPolicyLink(data) {
    const res = await api.post('/settings/policy-links', data)
    return res.data
  },

  async updatePolicyLink(id, data) {
    const res = await api.put(`/settings/policy-links/${id}`, data)
    return res.data
  },

  async deletePolicyLink(id) {
    const res = await api.delete(`/settings/policy-links/${id}`)
    return res.data
  },

  // =========================
  // 🎨 BRANDING
  // =========================
  async getBranding() {
    const res = await api.get('/settings/branding')
    return res.data
  },

  async updateBranding(data) {
  
    try {
      // supports form-data (logo upload)
      const res = await api.post('/settings/branding', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return res.data
    } catch (error) {
      const err = error.response
      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.errors || {}
      }
    }
  },

  // =========================
  // 🛒 CHECKOUT SETTINGS
  // =========================
  async getCheckout() {
    const res = await api.get('/settings/checkout')
    return res.data
  },

  async updateCheckout(data) {
    const res = await api.put('/settings/checkout', data)
    return res.data
  },

   async getResellerMarkup(data) {
    const res = await api.get('/settings/reseller-markup', data)
    return res.data
  },

  async saveResellerMarkup(data) {
    try {
      const res = await api.put('/settings/reseller-markup', data)
      return res.data
    } catch (error) {
      const err = error.response
      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.errors || {}
      }
    }
  }
}